export default __webpack_public_path__ + "static/media/RadicalRocks_11.69cb72be.png";